// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.robot-selection {
    margin: 20px 0;
  }
  
  select {
    padding: 10px;
    width: 200px;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Common.css"],"names":[],"mappings":"AAAA;IACI,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,YAAY;EACd","sourcesContent":[".robot-selection {\n    margin: 20px 0;\n  }\n  \n  select {\n    padding: 10px;\n    width: 200px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
